import { createFileRoute } from '@tanstack/react-router';

import { ComingSoon } from '@/components/common/ComingSoon';
import { m } from '@/paraglide/messages';

export const Route = createFileRoute('/{-$locale}/')({
  component: DashboardPage,
});

function DashboardPage() {
  return <ComingSoon title={m.page_dashboard()} />;
}
